import client from '@/app/config/axios'

export default class GenericService {

    constructor(requestUrl){
        this.requestUrl = requestUrl;
        this.api = client;
    }

    getApi = () => {
        return this.api;
    }

    request = ({method, query, body, config}) => {
        let queryString = query || ''
        let url = `${this.requestUrl}`

        if(queryString && queryString.indexOf('?') < 0){
            url = url + "/"
        }

        url  = `${url}${queryString}`
        return this.api[method](url, body, config )
    }

    get = (query) => {
        return this.request({method: 'get', query})
    }

    post = (body) => {
        return this.request({method: 'post', body})
    }

    put = (query, body) => {
        return this.request({method: 'put', query, body})
    }

    delete = (query) => {
        return this.request({method: 'put', query})
    }
}